// UPDATED Header Component with Compact Profile Card (replaces dropdown menu)

import React, { useState, useEffect, useRef } from 'react';
import styles from './Header.module.css';
import { logout } from '../../utils/authTokens';
import logo from '../../assets/images/logo.png';
import ProfileCard from '../profilecard/ProfileCard.tsx';

interface IDefineHeaderProps {
  currentModule?: string;
  userName?: string;
  userRole?: string;
  email?: string;
}

const IDefineHeader: React.FC<IDefineHeaderProps> = ({ 
  currentModule = 'Dashboard',
  userName = 'Dr. John Doe',
  userRole = 'Administrator',
  email = 'john.doe@example.com'
}) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false); // Keep this for the old dropdown
  const [showProfileCard, setShowProfileCard] = useState(false); // NEW for profile card
  
  const notificationRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);

  // Parse user name
  const [firstName, ...lastNameParts] = userName.split(' ');
  const lastName = lastNameParts.join(' ');

  // User profile data
  const userProfile = {
    firstName: firstName || 'John',
    lastName: lastName || 'Doe',
    email: email,
    contactNumber: '(234) 718-1235', // Get from your user context
    role: userRole,
    avatar: undefined
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
        setShowProfileMenu(false);
        setShowProfileCard(false); // Close profile card too
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
  };

  // NEW: Handle "My Profile" click - show card, hide menu
  const handleMyProfileClick = () => {
    setShowProfileMenu(false); // Close dropdown menu
    setShowProfileCard(true);   // Show profile card
  };

  // NEW: Handle profile save
  const handleProfileSave = (updatedProfile: any) => {
    console.log('Profile updated:', updatedProfile);
    // TODO: Call your API to update profile
    // updateUserProfile(updatedProfile);
  };

  return (
    <>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          {/* Left Section - Brand */}
          <div className={styles.leftSection}>
            {/* Mobile Menu Button */}
            <button 
              className={styles.mobileMenuButton} 
              onClick={() => (window as any).openSidebar?.()}
              aria-label="Open Menu"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>

            <div className={styles.brandContainer}>
              <div className={styles.logoWrapper}>
                <img src={logo} alt="Logo" className={styles.logoImage} />
              </div>
              
              {/* <span className={styles.brandText}>SynoSYS</span> */}
            </div>
          </div>

          {/* Right Section - Actions */}
          <div className={styles.rightSection}>
            <div className={styles.dropdownWrapper} ref={notificationRef}>
              <button 
                className={styles.actionButton}
                onClick={() => setShowNotifications(!showNotifications)}
                title="Notifications"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path 
                    d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round"
                  />
                </svg>
                <span className={styles.notificationBadge}>3</span>
              </button>

              {showNotifications && (
                <div className={styles.notificationDropdown}>
                  <div className={styles.dropdownHeader}>
                    <h3>Notifications</h3>
                    <button className={styles.markAllRead}>Mark all read</button>
                  </div>
                  <div className={styles.notificationList}>
                    <div className={styles.notificationItem}>
                      <div className={styles.notifIconWrapper}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M9 11l3 3L22 4" stroke="#80b149" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="#0c6577" strokeWidth="2"/>
                        </svg>
                      </div>
                      <div className={styles.notifContent}>
                        <p className={styles.notifTitle}>Report generated successfully</p>
                        <p className={styles.notifTime}>5 minutes ago</p>
                      </div>
                    </div>
                    <div className={styles.notificationItem}>
                      <div className={styles.notifIconWrapper}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="#0c6577" strokeWidth="2"/>
                          <circle cx="9" cy="7" r="4" stroke="#80b149" strokeWidth="2"/>
                        </svg>
                      </div>
                      <div className={styles.notifContent}>
                        <p className={styles.notifTitle}>New record added</p>
                        <p className={styles.notifTime}>1 hour ago</p>
                      </div>
                    </div>
                    <div className={styles.notificationItem}>
                      <div className={styles.notifIconWrapper}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <rect x="3" y="3" width="18" height="18" rx="2" stroke="#0c6577" strokeWidth="2"/>
                          <path d="M3 9h18M9 3v6" stroke="#b6d438" strokeWidth="2"/>
                        </svg>
                      </div>
                      <div className={styles.notifContent}>
                        <p className={styles.notifTitle}>Study phase 2 completed</p>
                        <p className={styles.notifTime}>3 hours ago</p>
                      </div>
                    </div>
                  </div>
                  <button className={styles.viewAllNotifications}>View all notifications</button>
                </div>
              )}
            </div>

            {/* User Profile */}
            <div className={styles.dropdownWrapper} ref={profileRef}>
              <button 
                className={styles.userProfile}
                onClick={() => {
                  setShowProfileMenu(!showProfileMenu);
                  setShowProfileCard(false); // Close profile card when toggling menu
                }}
              >
                <div className={styles.userAvatar}>
                  <span>{userName.split(' ').map(n => n[0]).join('')}</span>
                </div>
                <div className={styles.userInfo}>
                  <span className={styles.userName}>{userName}</span>
                  <span className={styles.userRole}>{userRole}</span>
                </div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className={styles.chevron}>
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>

              {/* OLD MENU - Only show if profile card is not showing */}
              {showProfileMenu && !showProfileCard && (
                <div className={styles.profileDropdown}>
                  <div className={styles.profileDropdownHeader}>
                    <div className={styles.userAvatarLarge}>
                      {userName.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div>
                      <p className={styles.profileName}>{userName}</p>
                      <p className={styles.profileEmail}>{email.toLowerCase()}</p>
                    </div>
                  </div>
                  <div className={styles.dropdownDivider}></div>
                  
                  {/* UPDATED: Show profile card instead */}
                  <button 
                    className={styles.dropdownMenuItem}
                    onClick={handleMyProfileClick}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    My Profile
                  </button>
                  
                  <div className={styles.dropdownDivider}></div>
                  <button className={`${styles.dropdownMenuItem} ${styles.dangerItem}`} onClick={handleLogout}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    Sign Out
                  </button>
                </div>
              )}

              {/* NEW: Profile Card - Show in place of menu */}
              {showProfileCard && (
                <ProfileCard
                  userProfile={userProfile}
                  onSave={handleProfileSave}
                />
              )}
            </div>
          </div>
        </div>

        {/* Bottom accent line */}
        <div className={styles.accentLine}></div>
      </header>
    </>
  );
};

export default IDefineHeader;